export const ENTITIES = {
  student: 'Estudiante',
  tutor: 'Tutor/Padre',
  teacher: 'Profesor',
};
